<template>
  <div class="entrustOrderCreate">
    <van-form label-width="120px">
      <div class="entrustOrderCreate-title">{{ $t.meta.basicTitle }}</div>

      <van-field
        v-model="form.Customer.text"
        :label="$t.salesManagement.orderCustomer"
        :placeholder="$t.meta.input"
        @click="onShowEmit('showCustomer')"
        clickable
        readonly
        v-if="!CustomerId"
      />

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.meta.businessType }}</div>
        <van-radio-group
          v-model="form.BusinessType"
          direction="horizontal"
          @change="getCountrys"
        >
          <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
        </van-radio-group>
      </div>

      <div class="entrustOrderCreate-title">
        <div class="title-left">{{ $t.salesManagement.shipper }}</div>
        <div class="title-right">
          <van-switch
            v-model="form.ShipperTBA"
            :active-value="1"
            :inactive-value="0"
            size="24"
          />
          <div class="later">{{ $t.salesManagement.later }}</div>
        </div>
      </div>

      <van-field
        v-model="form.Shipper.CompanyName"
        :label="$t.salesManagement.companyName"
        :placeholder="$t.meta.input"
        :disabled="form.ShipperTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Shipper.ContactPhone"
        :label="$t.salesManagement.contactPhone"
        :placeholder="$t.meta.input"
        :disabled="form.ShipperTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Shipper.Address"
        :label="$t.salesManagement.address"
        :placeholder="$t.meta.input"
        type="textarea"
        :disabled="form.ShipperTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Shipper.Email"
        :label="$t.salesManagement.email"
        :placeholder="$t.meta.input"
        :disabled="form.ShipperTBA == 1 ? true : false"
      />

      <div class="entrustOrderCreate-title">
        <div class="title-left">{{ $t.salesManagement.consignee }}</div>
        <div class="title-right">
          <van-switch
            v-model="form.ConsigneeTBA"
            :active-value="1"
            :inactive-value="0"
            size="24"
          />
          <div class="later">{{ $t.salesManagement.later }}</div>
        </div>
      </div>

      <van-field
        v-model="form.Consignee.CompanyName"
        :label="$t.salesManagement.companyName"
        :placeholder="$t.meta.input"
        :disabled="form.ConsigneeTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Consignee.ContactPhone"
        :label="$t.salesManagement.contactPhone"
        :placeholder="$t.meta.input"
        :disabled="form.ConsigneeTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Consignee.Address"
        :label="$t.salesManagement.address"
        :placeholder="$t.meta.input"
        type="textarea"
        :disabled="form.ConsigneeTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Consignee.Email"
        :label="$t.salesManagement.email"
        :placeholder="$t.meta.input"
        :disabled="form.ConsigneeTBA == 1 ? true : false"
      />

      <div class="entrustOrderCreate-title">
        <div class="title-left">{{ $t.salesManagement.notify }}</div>
        <div class="title-right">
          <van-switch
            v-model="form.NotifyTBA"
            :active-value="1"
            :inactive-value="0"
            size="24"
          />
          <div class="later">{{ $t.salesManagement.later }}</div>
        </div>
      </div>

      <van-field :label="$t.salesManagement.same" readonly>
        <template #right-icon>
          <van-switch
            v-model="form.SameAsConsignee"
            :active-value="1"
            :inactive-value="0"
            size="24"
          />
        </template>
      </van-field>

      <van-field
        v-model="form.Notify.CompanyName"
        :label="$t.salesManagement.companyName"
        :placeholder="$t.meta.input"
        :disabled="form.NotifyTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Notify.ContactPhone"
        :label="$t.salesManagement.contactPhone"
        :placeholder="$t.meta.input"
        :disabled="form.NotifyTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Notify.Address"
        :label="$t.salesManagement.address"
        :placeholder="$t.meta.input"
        type="textarea"
        :disabled="form.NotifyTBA == 1 ? true : false"
      />

      <van-field
        v-model="form.Notify.Email"
        :label="$t.salesManagement.email"
        :placeholder="$t.meta.input"
        :disabled="form.NotifyTBA == 1 ? true : false"
      />

      <div class="entrustOrderCreate-title">
        {{ $t.salesManagement.deliveryCity }}
      </div>

      <van-field
        clickable
        readonly
        :value="form.Delivery.CountryText"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDeliveryCountry')"
      />

      <van-field
        clickable
        readonly
        :value="form.Delivery.CityText"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDeliveryCity')"
      />

      <div class="entrustOrderCreate-title">
        {{ $t.salesManagement.destinationCity }}
      </div>

      <van-field
        clickable
        readonly
        :value="form.Destination.CountryText"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDestinationCountry')"
      />

      <van-field
        clickable
        readonly
        :value="form.Destination.CityText"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDestinationCity')"
      />

      <div class="entrustOrderCreate-title">
        {{ $t.salesManagement.title2 }}
      </div>

      <van-field
        v-model="form.GoodsName"
        :label="$t.salesManagement.goodsName"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.TCName"
        :label="$t.salesManagement.tradeTerms"
        @click="pickerShow('showTCIdPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.brand }}</div>
        <van-radio-group v-model="form.Brand" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.liquid }}</div>
        <van-radio-group v-model="form.Liquid" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.powder }}</div>
        <van-radio-group v-model="form.Powder" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.magnetic }}</div>
        <van-radio-group v-model="form.Magnetic" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.entrustType }}</div>
        <van-radio-group v-model="form.ExportType" direction="horizontal">
          <van-radio :name="1">{{ $t.salesManagement.export1 }}</van-radio>
          <van-radio :name="2">{{ $t.salesManagement.export2 }}</van-radio>
          <van-radio :name="3">{{ $t.salesManagement.export3 }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        v-model="form.NumberPackages.number"
        :label="$t.salesManagement.pNumber"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-model="form.NumberPackages.text"
        :label="$t.salesManagement.piecesUnit"
        @click="pickerShow('showNumberPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.Volume.number"
        :label="$t.salesManagement.volume"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-model="form.Volume.text"
        :label="$t.salesManagement.volumeUnit"
        @click="pickerShow('showVolumePicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.Weight.number"
        :label="$t.salesManagement.weight"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-model="form.Weight.text"
        :label="$t.salesManagement.weightUnit"
        @click="pickerShow('showWeightPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.ECDName"
        :label="$t.salesManagement.commission"
        @click="pickerShow('showECDIdPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.FPName"
        :label="$t.salesManagement.costPay"
        @click="pickerShow('showItemPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <div class="entrustOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.tdService }}</div>
        <van-radio-group v-model="form.TakeDeliveryService" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="entrustOrderCreate-title" v-if="form.TakeDeliveryService == 1">
        {{ $t.salesManagement.tdLocation }}
      </div>

      <van-field
        clickable
        readonly
        :value="form.TakeDelivery.CountryText"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showTakeDeliveryCountry')"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field
        clickable
        readonly
        :value="form.TakeDelivery.CityText"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showTakeDeliveryCity')"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field
        v-model="form.TakeDeliveryContactPerson"
        :label="$t.salesManagement.takeDeliveryPerson"
        :placeholder="$t.meta.input"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field
        v-model="form.TakeDeliveryContactPhone"
        :label="$t.salesManagement.takeDeliveryContactPhone"
        :placeholder="$t.meta.input"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field
        v-model="form.TakeDeliveryAddress"
        :label="$t.salesManagement.takeDeliveryAddress"
        :placeholder="$t.meta.input"
        type="textarea"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field :label="$t.salesManagement.rule">
        <template #input>
          <van-image
            width="80"
            height="80"
            fit="cover"
            :src="form.rule"
            @click="imagePreview(form.rule)"
          />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <!-- 入仓委托企业 -->
    <fetch-list
      event="showCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <!-- 发货地 -->
    <option-list
      event="showDeliveryCountry"
      :options="countryList"
      @onSelect="onSelectDeliveryCountry"
    ></option-list>

    <option-list
      event="showDeliveryCity"
      :options="deliveryCityList"
      @onSelect="onSelectDeliveryCity"
    ></option-list>

    <!-- 目的地 -->
    <option-list
      event="showDestinationCountry"
      :options="countryList"
      @onSelect="onSelectDestinationCountry"
    ></option-list>

    <option-list
      event="showDestinationCity"
      :options="destinationCityList"
      @onSelect="onSelectDestinationCity"
    ></option-list>

    <!-- 提货地点 -->
    <option-list
      event="showTakeDeliveryCountry"
      :options="countryList"
      @onSelect="onSelectTakeDeliveryCountry"
    ></option-list>

    <option-list
      event="showTakeDeliveryCity"
      :options="takeDeliveryCityList"
      @onSelect="onSelectTakeDeliveryCity"
    ></option-list>

    <van-popup v-model="showTCIdPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.tradeTerms"
        show-toolbar
        :columns="tcList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="tcidConfirm"
        @cancel="showTCIdPicker = false"
      />
    </van-popup>

    <van-popup v-model="showNumberPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.piecesUnit"
        show-toolbar
        :columns="packageList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="numberConfirm"
        @cancel="showNumberPicker = false"
      />
    </van-popup>

    <van-popup v-model="showVolumePicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.volumeUnit"
        show-toolbar
        :columns="volumeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="volumeConfirm"
        @cancel="showVolumePicker = false"
      />
    </van-popup>

    <van-popup v-model="showWeightPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.weightUnit"
        show-toolbar
        :columns="weightList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="weightConfirm"
        @cancel="showWeightPicker = false"
      />
    </van-popup>

    <van-popup v-model="showECDIdPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.commission"
        show-toolbar
        :columns="ecdList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="ecdConfirm"
        @cancel="showECDIdPicker = false"
      />
    </van-popup>

    <van-popup v-model="showItemPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.costPay"
        show-toolbar
        :columns="fpList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="itemConfirm"
        @cancel="showItemPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  ImagePreview,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(ImagePreview)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "entrustOrderCreate",
  components: {
    FetchList,
    OptionList,
  },
  data() {
    return {
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      form: {
        BusinessType: 1,
        ShipperTBA: 0,
        Shipper: {},
        ConsigneeTBA: 0,
        Consignee: {},
        NotifyTBA: 0,
        Notify: {},
        SameAsConsignee: 0,
        Delivery: {},
        Destination: {},
        GoodsName: "",
        TCName: "",
        TCId: "",
        NumberPackages: {
          number: null,
          text: "",
          value: "",
        },
        Volume: {
          number: null,
          text: "",
          value: "",
        },
        Weight: {
          number: null,
          text: "",
          value: "",
        },
        Brand: 0,
        Liquid: 0,
        Powder: 0,
        Magnetic: 0,
        ExportType: 2,
        TakeDeliveryService: 0,
        TakeDelivery: {},
        TakeDeliveryContactPerson: "",
        TakeDeliveryContactPhone: "",
        TakeDeliveryAddress: "",
        ECDName: "",
        ECDId: "",
        FPName: "",
        FPId: "",
        rule: require("@/assets/img/salesManagement/entrustOrder.jpg"),
        Customer: { value: "" }, //value,CustomerNumber
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      },
      //国家城市选项
      countryList: [],
      deliveryCityList: [],
      destinationCityList: [],
      takeDeliveryCityList: [],
      //货运选项
      settings: [],
      tcList: [],
      ecdList: [],
      packageList: [],
      volumeList: [],
      weightList: [],
      fpList: [],
      //picker
      showTCIdPicker: false,
      showNumberPicker: false,
      showVolumePicker: false,
      showWeightPicker: false,
      showECDIdPicker: false,
      showItemPicker: false,
    };
  },
  created() {
    this.getCountrys();
    this.getEntrustOrderSetting();
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(data) {
      ImagePreview({ images: [data], closeable: true, startPosition: 0 });
    },
    getEntrustOrderSetting() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.salesManagement
          .getEntrustOrderSetting()
          .then((res) => {
            this.settings = res.data;

            var tcList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.TCName,
                value: item.TCId,
              };
              tcList.push(data);
            });
            this.tcList = this.$commonMethod.deepClone(tcList);

            var ecdList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.ECDName,
                value: item.ECDId,
              };
              ecdList.push(data);
            });
            this.ecdList = this.$commonMethod.deepClone(ecdList);

            var fpList = [];
            this.settings[2].forEach((item) => {
              let data = {
                text: item.FPName,
                value: item.FPId,
              };
              fpList.push(data);
            });
            this.fpList = this.$commonMethod.deepClone(fpList);

            var packageList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.NPUId,
              };
              packageList.push(data);
            });
            this.packageList = this.$commonMethod.deepClone(packageList);

            var volumeList = [];
            this.settings[4].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.VUId,
              };
              volumeList.push(data);
            });
            this.volumeList = this.$commonMethod.deepClone(volumeList);

            var weightList = [];
            this.settings[5].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.WUId,
              };
              weightList.push(data);
            });
            this.weightList = this.$commonMethod.deepClone(weightList);

            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    tcidConfirm(e) {
      this.form.TCName = e.text;
      this.form.TCId = e.value;
      this.showTCIdPicker = false;
    },
    numberConfirm(e) {
      this.form.NumberPackages.text = e.text;
      this.form.NumberPackages.value = e.value;
      this.showNumberPicker = false;
    },
    volumeConfirm(e) {
      this.form.Volume.text = e.text;
      this.form.Volume.value = e.value;
      this.showVolumePicker = false;
    },
    weightConfirm(e) {
      this.form.Weight.text = e.text;
      this.form.Weight.value = e.value;
      this.showWeightPicker = false;
    },
    ecdConfirm(e) {
      this.form.ECDName = e.text;
      this.form.ECDId = e.value;
      this.showECDIdPicker = false;
    },
    itemConfirm(e) {
      this.form.FPName = e.text;
      this.form.FPId = e.value;
      this.showItemPicker = false;
    },
    //入仓委托企业
    onSelectCustomer(e) {
      this.form.Customer.text = e.text;
      this.form.Customer.value = e.value;
      this.form.Customer.CustomerNumber = e.CustomerNumber;
      this.$forceUpdate();
    },
    //发货地
    onSelectDeliveryCountry(e) {
      this.form.Delivery.CountryText = e.text;
      this.form.Delivery.CountryId = e.value;
      this.getCities("delivery", e.value);
      this.$forceUpdate();
    },
    onSelectDeliveryCity(e) {
      this.form.Delivery.CityText = e.text;
      this.form.Delivery.CityId = e.value;
      this.$forceUpdate();
    },
    //目的地
    onSelectDestinationCountry(e) {
      this.form.Destination.CountryText = e.text;
      this.form.Destination.CountryId = e.value;
      this.getCities("destination", e.value);
      this.$forceUpdate();
    },
    onSelectDestinationCity(e) {
      this.form.Destination.CityText = e.text;
      this.form.Destination.CityId = e.value;
      this.$forceUpdate();
    },
    //提货地点
    onSelectTakeDeliveryCountry(e) {
      this.form.TakeDelivery.CountryText = e.text;
      this.form.TakeDelivery.CountryId = e.value;
      this.getCities("pickup", e.value);
      this.$forceUpdate();
    },
    onSelectTakeDeliveryCity(e) {
      this.form.TakeDelivery.CityText = e.text;
      this.form.TakeDelivery.CityId = e.value;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      var param = {
        CustomerId: this.CustomerId ? this.CustomerId : this.form.Customer.value,
        BusinessType: this.form.BusinessType,
        ShipperTBA: this.form.ShipperTBA,
        ConsigneeTBA: this.form.ConsigneeTBA,
        NotifyTBA: this.form.NotifyTBA,
        SameAsConsignee: this.form.SameAsConsignee,
        DeliveryCountryId: this.form.Delivery.CountryId,
        DeliveryCityId: this.form.Delivery.CityId,
        DestinationCountryId: this.form.Destination.CountryId,
        DestinationCityId: this.form.Destination.CityId,
        GoodsName: this.form.GoodsName,
        TCId: parseInt(this.form.TCId),
        NumberPackages: parseInt(this.form.NumberPackages.number),
        NPUId: parseInt(this.form.NumberPackages.value),
        Volume: parseFloat(this.form.Volume.number),
        VUId: parseInt(this.form.Volume.value),
        Weight: parseFloat(this.form.Weight.number),
        WUId: parseInt(this.form.Weight.value),
        Brand: this.form.Brand,
        Liquid: this.form.Liquid,
        Powder: this.form.Powder,
        Magnetic: this.form.Magnetic,
        ExportType: this.form.ExportType,
        TakeDeliveryService: this.form.TakeDeliveryService,
        TakeDeliveryCountry: this.form.TakeDelivery.CountryId,
        TakeDeliveryCity: this.form.TakeDelivery.CityId,
        TakeDeliveryContactPerson: this.form.TakeDeliveryContactPerson,
        TakeDeliveryContactPhone: this.form.TakeDeliveryContactPhone,
        TakeDeliveryAddress: this.form.TakeDeliveryAddress,
        ECDId: parseInt(this.form.ECDId),
        FPId: parseInt(this.form.FPId),
        ContactRecordList: [],
        UserId: this.form.UserId,
        CompanyId: this.form.CompanyId,
      };
      if (!this.form.ShipperTBA) {
        var shipper = {
          ContactType: 1,
        };
        shipper.CustomerId = this.form.Customer.value;
        shipper.CompanyName = this.form.Shipper.CompanyName;
        shipper.ContactPhone = this.form.Shipper.ContactPhone;
        shipper.Address = this.form.Shipper.Address;
        shipper.Email = this.form.Shipper.Email;
        param.ContactRecordList.push(shipper);
      }
      if (!this.form.ConsigneeTBA) {
        var consignee = {
          ContactType: 2,
        };
        consignee.CustomerId = this.form.Customer.value;
        consignee.CompanyName = this.form.Consignee.CompanyName;
        consignee.ContactPhone = this.form.Consignee.ContactPhone;
        consignee.Address = this.form.Consignee.Address;
        consignee.Email = this.form.Consignee.Email;
        param.ContactRecordList.push(consignee);
      }
      if (!this.form.NotifyTBA) {
        var notify = {
          ContactType: 3,
        };
        notify.CustomerId = this.form.Customer.value;
        notify.CompanyName = this.form.Notify.CompanyName;
        notify.ContactPhone = this.form.Notify.ContactPhone;
        notify.Address = this.form.Notify.Address;
        notify.Email = this.form.Notify.Email;
        param.ContactRecordList.push(notify);
      }
      this.$commonMethod.showLoading();
      this.$api.myCustomer
        .addEntrustOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onClearArea() {
      this.form.Delivery.CountryText = "";
      this.form.Delivery.CountryId = null;
      this.form.Delivery.CityText = "";
      this.form.Delivery.CityId = null;
      this.form.Destination.CountryText = "";
      this.form.Destination.CountryId = null;
      this.form.Destination.CityText = "";
      this.form.Destination.CityId = null;
      this.form.TakeDelivery.CountryText = "";
      this.form.TakeDelivery.CountryId = null;
      this.form.TakeDelivery.CityText = "";
      this.form.TakeDelivery.CityId = null;
    },
    getCountrys() {
      return new Promise((resolve) => {
        let param = {
          BusinessType: this.form.BusinessType,
        };
        this.$api.myCustomer
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + " , " + item.CountryName_en,
                value: item.CountryId,
                CityList: item.CityList,
              };
              result.push(data);
            });
            this.countryList = result;
            this.onClearArea();
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCities(type, countryId) {
      var formatCity = (cities) => {
        var result = [];
        cities.forEach((item) => {
          let data = {
            text: item.City_cn + " , " + item.City_en,
            value: item.CityId,
          };
          result.push(data);
        });
        return result;
      };
      for (let country of this.countryList) {
        if (country.value == countryId) {
          if (type == "delivery") {
            this.deliveryCityList = formatCity(country.CityList);
            this.form.Delivery.CityText = "";
            this.form.Delivery.CityId = null;
          }
          if (type == "destination") {
            this.destinationCityList = formatCity(country.CityList);
            this.form.Destination.CityText = "";
            this.form.Destination.CityId = null;
          }
          if (type == "pickup") {
            this.takeDeliveryCityList = formatCity(country.CityList);
            this.form.TakeDelivery.CityText = "";
            this.form.TakeDelivery.CityId = null;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.entrustOrderCreate {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .entrustOrderCreate-title {
    font-size: 14px;
    padding: 15px;
    color: #1890ff;
    background: #f1f1f1;

    .title-left {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      color: #1890ff;
    }

    .title-right {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      text-align: right;
      color: #999;

      .van-switch {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }

      .later {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  .entrustOrderCreate-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>
